<template lang="pug">
SspLayout(area="core")
  template(slot="actions")
    button.btn.btn-default(type="button" @click="toggleMode") {{editMode ? 'Cancel' : 'Edit Organization'}}
  .row(v-if="organization")
    .col-md-12
      .panel.panel-default
        .panel-heading
          h3.panel-title {{organization.name}} Details
        .panel-body(v-if="!editMode")
          .container-fluid
            .row
              label.col-sm-2 Name
              .col-sm-4 {{organization.name}}
            .row()
              label.col-sm-2 Email
              .col-sm-4 {{organization.email}}
            .row
              label.col-sm-2 Prefix
              .col-sm-4(v-if="organization.gs1Prefix") {{organization.gs1Prefix}}
              em.text-muted.col-sm-4(v-else) Not set
        form(@submit.prevent="save" v-else)
          .panel-body
            .form-horizontal
                .form-group
                  label.col-sm-1.control-label Name
                  .col-sm-4
                    input.focus.col-sm-4.form-control(v-model="organization.name" type="text" placeholder="Organization Name")
                .form-group
                  label.col-sm-1.control-label Email
                  .col-sm-4
                    input.col-sm-4.form-control(v-model="organization.email" type="email" placeholder="Organization Name")
                .form-group
                  label.col-sm-1.control-label Prefix
                  .col-sm-4
                    input.col-sm-4.form-control(v-model="organization.gs1Prefix" type="text" placeholder="Organization gs1 Prefix")
          .panel-footer
            .text-right
              SspActionButton(type="submit" :disabled="!isValid" :spinning="saving")
</template>

<script>
import miniToastr from 'mini-toastr'
import Vue from 'vue'
import Security from '@/service/apis/Security'
import Util from '@/service/Util'

export default {
  data: () => ({
    saving: false,
    errorMsg: null,
    editMode: false,
    organization: null
  }),
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      Security.getOrganization()
        .then((resp) => {
          this.organization = resp.data.organization
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    toggleMode() {
      this.editMode = !this.editMode
      Vue.nextTick(() => {
        if (this.editMode) {
          if (document.activeElement) {
            document.activeElement.blur()
          }
          const focusElement = this.$el.querySelector('.focus')
          if (focusElement) {
            focusElement.focus()
          }
        }
      })
    },
    save() {
      this.saving = true
      Security.updateOrganization(this.organization.id, { organization: this.organization })
        .then(() => {
          miniToastr.success('Organization successfully updated')
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.editMode = false
          this.saving = false
        })
    }
  },
  computed: {
    isValid() {
      return this.organization.name && Util.validateEmail(this.organization.email)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/management/organization/ViewOrganization.vue